module.exports = __webpack_public_path__ + "media/images/seeds/steve-0a75a36183addd214fe83e184aea238b.png";